import React from 'react'

import ReviewsCard from 'app/components/cards/ReviewsCard'
import { getReviewDate } from 'app/utils/helpers/review.helpers'

type ReviewsCardRenderItemProps = {
  review: UserReviewsModel
  showAction: boolean
  loading?: boolean
}

const ReviewsCardRenderItem: RFC<ReviewsCardRenderItemProps> = ({
  review,
  showAction,
  loading
}) => {
  const reviewDate = getReviewDate(review?.created_at)
  const replyDate = getReviewDate(review?.reply_time)

  const fullNameSender =
    review?.sender?.store_name || review?.sender?.contact_name
  const fullNameReceiver =
    review?.receiver?.store_name || review?.receiver?.contact_name

  const isLoading = review?.isLoading || loading

  return (
    <ReviewsCard
      reviewId={review?.id}
      avatarUrl={review?.sender?.avatar?.url}
      fullName={fullNameSender}
      reviewDate={reviewDate}
      comment={review?.comment}
      rate={review?.main_rate}
      receiverAvatarUrl={review?.receiver?.avatar?.url}
      receiverFullName={fullNameReceiver}
      replyDate={replyDate}
      replyComment={review?.reply_comment}
      showAction={showAction}
      slug={review?.sender?.slug}
      loading={isLoading}
    />
  )
}

export default ReviewsCardRenderItem
